export default __webpack_public_path__ + "static/media/image-real-deal.a884e676.jpg";